import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">漫画分类索引</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            按类型快速浏览，找到你最爱的漫画专题合集
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group relative bg-background-50 rounded-xl p-5 md:p-6 border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <span className={`absolute top-3 right-3 text-[10px] font-medium text-background-50 px-2 py-0.5 rounded-full ${item.tagColor}`}>
                {item.tag}
              </span>
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.iconBg} mb-4`}>
                <i className={`${item.icon} text-xl ${item.iconColor}`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-3">{item.desc}</p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400">{item.count} 部作品</span>
                <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-500 group-hover:translate-x-1 transition-all text-sm"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}